import { colors } from "./colors";

export const borders = {
  small: `1px solid ${colors.base[2]}`,
  medium: `2px solid ${colors.base[2]}`,
  large: `3px solid ${colors.base[2]}`,
};
